import React, { useState } from "react";
import { FaSortAmountUp, FaSortAmountDown } from "react-icons/fa";

const TableauDynamique = ({
  colonnes,
  donnees,
  isLoading,
  messageAucun = "Aucune donnée trouvée.",
  onSelectRow,
  itemsPerPage = 10,
}) => {
  const [selectedRow, setSelectedRow] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPageState, setItemsPerPageState] = useState(itemsPerPage);
  const [searchTerm, setSearchTerm] = useState("");

  // État pour gérer le tri
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "ascending" });

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const handleRowClick = (item) => {
    // Si la même ligne est cliquée → désélectionner
    const newSelectedId = selectedRow === item.id ? null : item.id;
    setSelectedRow(newSelectedId);

    if (onSelectRow) {
      onSelectRow(newSelectedId ? item : null);
    }
  };


  const totalItems = donnees.length;
  const totalPages = Math.ceil(totalItems / itemsPerPageState);
  const indexOfLastItem = currentPage * itemsPerPageState;
  const indexOfFirstItem = indexOfLastItem - itemsPerPageState;

  // Filtrage des données en fonction du terme de recherche
  const donneesFiltrees = donnees.filter((item) =>
    colonnes.some((col) => {
      const value = item[col.cle]?.toString().toLowerCase() || "";
      return value.includes(searchTerm.toLowerCase());
    })
  );

  // Tri des données
  const donneesTriees = [...donneesFiltrees].sort((a, b) => {
    if (sortConfig.key) {
      const valueA = a[sortConfig.key]?.toString().toLowerCase() || "";
      const valueB = b[sortConfig.key]?.toString().toLowerCase() || "";
      if (valueA < valueB) {
        return sortConfig.direction === "ascending" ? -1 : 1;
      }
      if (valueA > valueB) {
        return sortConfig.direction === "ascending" ? 1 : -1;
      }
    }
    return 0;
  });

  const donneesAffichees = donneesTriees.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <select
          value={itemsPerPageState}
          onChange={(e) => {
            setItemsPerPageState(Number(e.target.value));
            setCurrentPage(1);
          }}
          className="form-select bg-light p-1"
          style={{ width: "auto", border: "1px black solid", borderRadius: "5px" }}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
        </select>

        <input
          type="text"
          placeholder="Rechercher..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="form-control"
          style={{ width: "300px" }}
        />
      </div>

      <div className="table-responsive">
        <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
          <thead>
            <tr>
              {colonnes.map((col, index) => (
                <th
                  key={index}
                  className="text-secondary text-wrap d-none d-md-table-cell"
                  onClick={() => handleSort(col.cle)}
                  style={{ cursor: "pointer" }}
                >
                  {col.titre}{" "}
                  {sortConfig.key === col.cle && sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={colonnes.length} className="text-center">
                  <div className="spinner-border mt-4" role="status">
                    <span className="visually-hidden"></span>
                  </div>
                </td>
              </tr>
            ) : donneesAffichees.length > 0 ? (
              donneesAffichees.map((item) => (
                <tr
                  key={item.id}
                  onClick={() => handleRowClick(item)}
                  className={selectedRow === item.id ? "bg-success text-white" : ""}
                  style={{ cursor: "pointer" }}
                >
                  {colonnes.map((col, idx) => (
                    <td key={idx} className="">{item[col.cle]}</td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={colonnes.length} className="text-center text-muted">
                  {messageAucun}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="d-flex justify-content-between align-items-center mt-3">
        <div>
          {donneesFiltrees.length === 0
            ? "Aucun élément à afficher"
            : `Affichage de ${indexOfFirstItem + 1} à ${indexOfLastItem > donneesFiltrees.length ? donneesFiltrees.length : indexOfLastItem} sur ${donneesFiltrees.length}`}
        </div>

        <div className="d-flex align-items-center">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            className={`badge ${currentPage === 1 ? "bg-secondary" : "bg-success"} mx-1`}
            style={{
              border: "1px solid #ccc",
              padding: "8px 12px",
              fontSize: "14px",
              cursor: currentPage > 1 ? "pointer" : "not-allowed",
              opacity: currentPage > 1 ? 1 : 0.6,
              color: "white",
            }}
            disabled={currentPage === 1}
          >
            &laquo;
          </button>

          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index + 1}
              onClick={() => setCurrentPage(index + 1)}
              className={`badge ${currentPage === index + 1 ? "badge-default" : "badge-light text-dark"} mx-1`}
              style={{
                border: "1px solid #ccc",
                padding: "8px 12px",
                fontSize: "14px",
                cursor: "pointer",
              }}
            >
              {index + 1}
            </button>
          ))}

          <button
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
            className={`badge ${currentPage === totalPages ? "bg-secondary" : "bg-success"} mx-1`}
            style={{
              border: "1px solid #ccc",
              padding: "8px 12px",
              fontSize: "14px",
              cursor: currentPage < totalPages ? "pointer" : "not-allowed",
              opacity: currentPage < totalPages ? 1 : 0.6,
              color: "white",
            }}
            disabled={currentPage === totalPages}
          >
            &raquo;
          </button>
        </div>
      </div>
    </div>
  );
};

export default TableauDynamique;
